import { createApi } from '@reduxjs/toolkit/query/react';
import { fetchBaseQueryWithAuth } from '../../fetchBaseQuery';
import { MerchantInsightsResponse, ErrorResponse } from './types';
import { runtimeConfig } from '../../../config/runtimeConfig';

export const insightsApi = createApi({
  reducerPath: 'insightsApi',
  tagTypes: ['MerchantInsights'],
  baseQuery: fetchBaseQueryWithAuth(runtimeConfig.omsApiBaseUrl || ''),
  endpoints: (builder) => ({
    getMerchantInsights: builder.query<MerchantInsightsResponse, { merchantId: string }>({
      query: ({ merchantId }) => ({
        url: `/merchants/${merchantId}/insights`,
        method: 'GET',
      }),
      providesTags: (_result, _error, { merchantId }) => [
        { type: 'MerchantInsights', id: merchantId },
      ],
      transformErrorResponse: (response: any): ErrorResponse => {
        if (response.data?.error) {
          return response.data;
        }

        return {
          error: {
            code: 'UNKNOWN_ERROR',
            message: response.data?.message || 'An unexpected error occurred',
            details: response.data,
          },
        };
      },
    }),
  }),
});

export const { useGetMerchantInsightsQuery } = insightsApi;
